import { render, staticRenderFns } from "./forgot-password.vue?vue&type=template&id=256b980f&"
import script from "./forgot-password.vue?vue&type=script&lang=js&"
export * from "./forgot-password.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports